export default {
    translations: 'Translations',
    logOut: 'Sgin Out',
    login: {
        playground: 'Go to Play Ground',
        login: 'Login',
        signup: 'Sign up',
        account: 'Account',
        password: 'Password',
        verifyCode: 'verify',
        weChat: 'weChat',
        qq: 'QQ'
    }
}



// WEBPACK FOOTER //
// ./src/language/en.js